import { AuthGate } from '../features/auth/components/AuthGate.jsx';
import { SessionProvider } from '../features/auth/SessionProvider.jsx';
import { ProfileGate } from '../features/profile/components/ProfileGate.jsx';
import { ProfileProvider } from '../features/profile/ProfileProvider.jsx';
import { ErrorBoundary } from '../ui/ErrorBoundary.jsx';
import { ToastViewport } from '../ui/ToastViewport.jsx';
import { AppShell } from './shell/AppShell.jsx';
import { ThemeProvider } from './theme/ThemeProvider.jsx';

/**
 * Application root.
 *
 * Providers, the root error boundary and the auth gate. Nothing else. The old
 * `App.jsx` was 1211 lines holding the state container, the calorie engine, the nudge
 * engine, the sync orchestrator, the global stylesheet and the page layout, with 22
 * useState and 12 useEffect hooks in one component.
 *
 * The boundary is outermost on purpose: if theme or session setup itself throws, the
 * fallback still renders, because its colours come from CSS custom properties rather
 * than from React state.
 *
 * Audit references prevented here: App.jsx #18, App.jsx #9, main.jsx #1, auth.jsx #1.
 */
export function App() {
  return (
    <ErrorBoundary label="EAX FUEL">
      <ThemeProvider>
        <ToastViewport />
        <SessionProvider>
          <AuthGate>
            <ProfileProvider>
              <ProfileGate>
                <AppShell />
              </ProfileGate>
            </ProfileProvider>
          </AuthGate>
        </SessionProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
